var globals = {};

globals.notes = [];

export default globals;